import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import CalendarPickerRecommendations from './Recommendations/CalendarPickerRecommendations'
import { getRecommendationsTitle } from './Recommendations/utils/recommendationsTitle'
import Modal from 'LuxKit/Modal/Modal'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { CalendarRecommendationsViewProvider, useCalendarRecommendationsView } from './CalendarRecommendationsViewContext'

interface Props {
  checkIn?: string
  monthIndex?: string
  duration: number
  offer: App.Offer
  rooms: Array<App.Occupants>
}

function OfferCalendarPickerRecommendationsModalView({
  offer,
  checkIn,
  duration,
  monthIndex,
  rooms,
}: Props) {
  const intl = useIntl()
  const { hasRenderableRecommendations } = useCalendarRecommendationsView()

  const similarTitle = useMemo(() => getRecommendationsTitle({
    checkIn,
    monthIndex,
    duration,
    intl,
  }).title, [checkIn, duration, monthIndex, intl])

  const context = useModalElementContext()

  const onBack = useCallback(() => {
    context.resolve()
  }, [context])

  return <Modal title={hasRenderableRecommendations ? similarTitle : undefined} onBack={onBack} height="max" size="L">
    <CalendarPickerRecommendations
      offerId={offer.id}
      offerType={offer.type}
      rooms={rooms}
      seedOffer={offer}
      duration={duration}
      checkIn={checkIn}
      monthIndex={monthIndex}
    />
  </Modal>
}

function OfferCalendarPickerRecommendationsModal(props: Props) {
  return (
    <CalendarRecommendationsViewProvider>
      <OfferCalendarPickerRecommendationsModalView {...props} />
    </CalendarRecommendationsViewProvider>
  )
}

export default withOfferPageState((state) => ({
  offer: state.offer,
  duration: state.duration,
  rooms: state.rooms,
}), OfferCalendarPickerRecommendationsModal)
